import { mapState } from 'vuex';
import viewMixin from '@/components/core/consumers/viewMixin';
export default {
  name: 'ViewConnectorsList',
  mixins: [viewMixin],
  data() {
    return {
      showCreateDialog: false,
      connector: {},
      accounts: [],
      loadingAccounts: true,
      selectedAccounts: []
    };
  },
  computed: {
    ...mapState('app', ['color']),
    ...mapState('authentication', ['tenantId']),
    isLoadingAccounts() {
      // combine loading states into one
      return this.loadingAccounts;
    }
  },
  watch: {
    selectedAccounts() {
      this.fetchTransformers(this.selectedAccounts);
    }
  },
  created() {
    this.fetchAccounts();
  },
  methods: {
    closeCreateDialog(reloadList = false) {
      if (reloadList) {
        this.$refs['bridges'].loadData();
      }
      this.showCreateDialog = false;
    },
    handleShowCreateDialog() {
      this.$refs.bridges.showCreateDialog();
    },
    fetchAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};